import React, { FC } from 'react'
import RenderHandler from '@kaidam/fc-shared/src/layout/RenderLayout'

import {
  ILayout,
  ILayout_Render_Context,
  ILayout_RenderMap,
} from '@kaidam/fc-shared/src/types/layout'

import TextRender from './renderers/Text'

interface LayoutRenderProps {
  data: ILayout,
  context: ILayout_Render_Context,
}

const LayoutRender: FC<React.PropsWithChildren<LayoutRenderProps>> = ({
  data,
  context,
}) => {

  const renderers: Partial<ILayout_RenderMap> = {}

  // if we are in preview mode - don't use the
  // full text renderer
  if(!context.preview) {
    renderers.text = TextRender
  }

  return (
    <RenderHandler
      data={ data }
      renderers={ renderers }
      context={ context }
    />
  )
}

export default LayoutRender